import React from 'react';
import {Stack} from '@mui/material';
import Header from './Header.js';
import Footer from './Footer.js';

const MainContainer = props=>{
    let {children, headerMargin=4, footerMargin} = props;
    return <Stack direction="column">
      <Header headerMargin={headerMargin}/>
      <main>
        {children}
      </main>
      <Footer footerMargin={footerMargin}/>
    </Stack>;
};

export default MainContainer;
